import { Component, OnInit } from '@angular/core';
import { AppLauncher, AppLauncherOptions } from '@ionic-native/app-launcher/ngx';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-external-app',
  templateUrl: './external-app.component.html',
  styleUrls: ['./external-app.component.scss']
})
export class ExternalAppComponent implements OnInit {

  constructor(private appLauncher: AppLauncher, private platform: Platform, private router: Router) { }

  launchApp() {
    const options: AppLauncherOptions = {
      packageName: 'com.google.android.gm',
    };

    if (this.platform.is('ios')) {
      options.uri = 'fb://';
    } else if (this.platform.is('android')) {
      options.packageName = 'com.google.android.gm';
      this.appLauncher.launch({packageName: 'com.google.android.gm'});
    }
    this.appLauncher.canLaunch(options)
      .then((canLaunch: boolean) => console.log('Gmail is available'))
      .catch((error: any) => {
        console.error('Gmail is not available');
        if (this.router.url === '/forgot-password') {
          alert ('Gmail App not found. Please open your mailbox and follow the link sent');
          this.router.navigateByUrl('/login');
        } else if (this.router.url === '/verify-email') {
          alert ('Gmail App not found. Please open your mailbox to get your verification code');
          return;
        }
      });
  }

  ngOnInit() {}

}

